<template>
  <div class="l_alert__coupon animation__background">
    <div class="l_alert__panel animation__popup">
      <div class="container" v-if="this.type === '1'">
        <div class="description">
          <p>本当にこのギフトを利用しますか？</p>
        </div>
        <div class="footer">
          <button @click="tapUse">利用する</button>
          <button @click="tapCancel">閉じる</button>
        </div>
      </div>
      <div class="container" v-else>
        <p class="title">利用のご確認</p>
        <div v-bind:class="{ freepass: this.isFreepass }" class="l_img">
          <img class="c_img" :src="this.image" />
        </div>
        <div class="description">
          <p>
            このクーポンを本当に使いますか？
          </p>
          <p v-if="this.isWeborder">次の画面で商品を選択してください。<br /></p>
          <p v-if="this.isWeborder" class="txt-highlight center">
            ※「使う」ボタンを押すと<br />
            クーポンは使用済みとなります。
          </p>
        </div>
        <div class="footer">
          <button @click="tapUse">使う</button>
          <button @click="tapCancel">今はやめる</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertCoupon',
  props: {
    image: {
      type: String
    },
    type: {
      type: String
    },
    isFreepass: {
      type: Boolean
    },
    isWeborder: {
      type: Boolean
    }
  },
  methods: {
    tapUse() {
      this.$emit('useCoupon')
    },
    tapCancel() {
      this.$emit('cancelCoupon')
    }
  }
}
</script>

<style lang="scss" scoped>
.l_alert__coupon {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
}

.l_alert__panel {
  width: 270px;
}

/* 背景表示のアニメーション */
.animation__background {
  animation: fadeIn 0.4s ease normal 0s none running;
}

/* popupアニメーション */
.animation__popup {
  animation: bounce 1s ease normal 0s none running;
}

@keyframes bounce {
  0%,
  100%,
  20%,
  50%,
  80% {
    transform: scale(1, 1);
  }

  40% {
    transform: scale(0.93, 0.93);
  }

  60% {
    transform: scale(0.98, 0.98);
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.l_alert__coupon .container {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: space-around;
  border: 1px solid #eeeeee;
  border-radius: 12px;
  background-color: #ffffff;
  padding: 20px 20px 0 20px;
}

.l_alert__coupon .container .title {
  font-family: 'HiraKakuPro-W6';
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
}

.l_img {
  width: 175px;
  min-height: 140px;
  overflow: hidden;
  margin-top: 20px;
  display: flex;
  align-items: center;
}

.freepass {
  height: 175px !important;
}

.c_img {
  max-width: 100%;
  vertical-align: bottom;
}

.l_alert__coupon .container .description {
  font-family: 'HiraKakuPro-W3';
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
  color: #333333;
  text-align: justify;
  padding: 15px 0 0;
}

.l_alert__coupon.container .description p:nth-child(1) {
  padding-top: 20px;
}

.l_alert__coupon .container .description p:nth-child(2) {
  padding-top: 4px;
}

.l_alert__coupon .container .description .txt-highlight {
  color: #e03535;
  &.center {
    margin: 4px 0;
    text-align: center;
  }
}

.l_alert__coupon .container .footer {
  padding-top: 25px;
  width: 100%;
}

.l_alert__coupon .container .footer button {
  font-family: 'HiraKakuPro-W3';
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  background-color: #ffffff;
  color: #602209;
  width: 50%;
  padding: 12px 0px;
  outline: none;
}

.l_alert__coupon .container .footer button:nth-child(1) {
  border: none;
  border-top: 1px solid #eeeeee;
  border-right: 1px solid #eeeeee;
  border-radius: 0 0 0 20px;
}

.l_alert__coupon .container .footer button:nth-child(2) {
  border: none;
  border-top: 1px solid #eeeeee;
  border-radius: 0 0 20px 0;
}
</style>
